import styles from './playlist-thumbnail.module.css'

import { LuListMusic } from '@react-icons/all-files/lu/LuListMusic'
import React from 'react'

import type { PlaylistTrackArtwork } from './playlists-loader'

// A playlist thumbnail: the playlist's own cover if it has one, else a 2×2
// mosaic of its track artworks, else a music-note placeholder.
const MOSAIC_CELLS = 4

const artworkUrl = (entry: PlaylistTrackArtwork): string =>
  entry.artwork_sizes?.['160x160'] ?? entry.artwork ?? ''

type Props = {
  imageUrl?: string | null
  artworks?: PlaylistTrackArtwork[]
  name: string
}

export const PlaylistThumbnail = ({ imageUrl, artworks, name }: Props) => {
  if (imageUrl) {
    return <img src={imageUrl} alt={name} className={styles.cover} />
  }

  const urls = (artworks ?? []).map(artworkUrl).filter(Boolean)

  if (urls.length === 0) {
    return (
      <span className={styles.fallback} aria-hidden="true">
        <LuListMusic />
      </span>
    )
  }

  // Fill four cells, cycling through however many artworks we have.
  const cells = Array.from(
    { length: MOSAIC_CELLS },
    (_, index) => urls[index % urls.length],
  )

  return (
    <span className={styles.mosaic} aria-hidden="true">
      {cells.map((url, index) => (
        <img key={index} src={url} alt="" className={styles.mosaicCell} />
      ))}
    </span>
  )
}
